/* eslint-disable no-console, no-return-assign  */
import wrapper from 'wrapper';
import pym from 'pym.js';
import Observer from './utils/observer';
import events from './utils/events-emitter';

events.on('inView', (el) => {
    injectIframe();
});
new Observer();

wrapper.markPageAsLoaded();

const containerID = `${DEV_SCAFFOLD('name')}-${DEV_SCAFFOLD('includeName')}`;
const url = wrapper.select(`#${containerID}`).dataset.embeduri;

function injectIframe() {
    const pymParent = new pym.Parent(containerID, url);

    pymParent.onMessage('requestHeight', () => {
        const windowHeight = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight
            || wrapper.scope.window.innerHeight
            || wrapper.scope.documentElement.clientHeight
            || wrapper.scope.body.clientHeight;
        const bannerElements = [].slice.call(document.querySelectorAll("[role='banner']"));
        let bannerHeight = 0;
        bannerElements.forEach((elm) => bannerHeight += elm.clientHeight);
        const availHeight = windowHeight - bannerHeight;
        pymParent.sendMessage('setHeight', availHeight);
    });
}
